export default [
	'comprar',
	'αγοραστε',
]